<rcp-button-container>
  <rcp-button-expandable-overlay-button
    [disabled]="isDisabled"
    [active]="isActive"
    [icon]="icon"
    [iconRightRotate]="iconRightRotate"
    [rcpPopover]="content"
    rcpPopoverVariation="menu"
    rcpPopoverMaxWidth="none"
    (rcpPopoverIsVisibleChange)="toggleIsActive($event)"
  >
    <ng-content select=".overlay-button-label"></ng-content>
  </rcp-button-expandable-overlay-button>

  <ng-template #content>
    <div class="overlay-content">
      <ng-content></ng-content>
    </div>
  </ng-template>
</rcp-button-container>
